import styled, { keyframes } from 'styled-components'
import dcoinsBg from '../../../../../assets/images/dcoins-bg.png'

export const Container = styled.div`
  position: fixed;
  width: 410px;
  top: 62px;
  bottom: 0;
  background-color: #fff;
  z-index: 10;
  transition: transform 0.2s ease-in-out;
  transform: translateX(${({ isOpen }) => (isOpen ? '0%' : '-100%')});

  @media screen and (max-width: 1024px) {
    top: 0;
    z-index: 1001;
    width: 375px;
  }

  @media screen and (max-width: 450px) {
    width: 100%;
  }
`

export const Overlay = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  @media screen and (max-width: 1024px) {
    z-index: 1000;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
`

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

// Header

export const Header = styled.div`
  background-image: url(${dcoinsBg});
  background-position: center;
  background-size: cover;
  padding: 10px 20px 25px;
`

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;

  &:first-child {
    margin-bottom: 15px;
  }
`

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  display: inline;
`

export const Back = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: -5px 0 0 -15px;
  cursor: pointer;
`

export const Balance = styled.span`
  margin-left: 8px;
  font-size: 36px;
  font-weight: 700;
`

export const Refill = styled.button`
  padding: 10px 45px;
  transition: 0.2s;
  color: white;
  background-color: #ff5e6d;
  border: 2px solid #ff5e6d;
  border-radius: 24px;
  font-weight: bold;
  font-size: 16px;
  margin-left: auto;
  cursor: pointer;

  &:hover {
    background-color: white;
    color: #ff5e6d;
  }
`

// Content

export const Content = styled.div`
  height: 100%;
  overflow-y: auto;
`

export const ContentTitle = styled(Title)`
  padding: 20px 15px 25px;
  display: block;
`

export const DateContainer = styled.div`
  padding: 0 25px 30px 15px;
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: 500;
  color: ${({ isToday }) => (isToday ? '#000' : '#8b8b8b')};
  border-bottom: 1px solid #f5f5f5;

  &:last-child {
    margin: 0;
    border: 0;
  }
`

// Item

export const Item = styled.div`
  display: flex;
  padding-top: 20px;
  position: relative;
`

export const AmountContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
`

export const Difference = styled.div`
  margin-top: 5px;
  font-size: 14px;
  font-weight: 700;
  color: #ff5e6d;
`

export const Description = styled.p`
  margin: 10px auto 0 20px;
  max-width: 165px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #000;
`

export const Image = styled.img`
  margin-left: auto;
  width: 56px;
  height: 56px;
  object-fit: contain;
`

export const Gift = styled.div`
  position: absolute;
  right: 40px;
  top: 70px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  background-image: url(${({ url }) => url});
  background-position: center;
  background-size: cover;
`
export const LoadMore = styled.div`
  display: flex;
  padding: 50px;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  color: #8b8b8b;
`

const loading = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

export const LoadMoreIcon = styled.div`
  margin-right: 10px;
  animation: ${loading} 1s linear infinite;
`
